/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1PersonIdPhotoMutationRequest,
  PostApiV1PersonIdPhotoMutationResponse,
  PostApiV1PersonIdPhotoPathParams,
  PostApiV1PersonIdPhoto400,
  PostApiV1PersonIdPhoto401,
  PostApiV1PersonIdPhoto404,
  PostApiV1PersonIdPhoto500,
} from "../../types/personRegisterController/PostApiV1PersonIdPhoto.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1PersonIdPhoto } from "../../clients/personRegisterController/postApiV1PersonIdPhoto.ts";

export const postApiV1PersonIdPhotoMutationKey = () =>
  [{ url: "/api/v1/person/:id/photo" }] as const;

export type PostApiV1PersonIdPhotoMutationKey = ReturnType<
  typeof postApiV1PersonIdPhotoMutationKey
>;

export function postApiV1PersonIdPhotoMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1PersonIdPhotoMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1PersonIdPhotoMutationKey();
  return mutationOptions<
    PostApiV1PersonIdPhotoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdPhoto400
      | PostApiV1PersonIdPhoto401
      | PostApiV1PersonIdPhoto404
      | PostApiV1PersonIdPhoto500
    >,
    {
      id: PostApiV1PersonIdPhotoPathParams["id"];
      data?: PostApiV1PersonIdPhotoMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return postApiV1PersonIdPhoto(id, data, config);
    },
  });
}

/**
 * @description Faz upload da foto de perfil. Sobrescreve a foto anterior, se existir. **(Requer Authorization para autenticação)**
 * @summary Enviar foto de perfil (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/photo}
 */
export function usePostApiV1PersonIdPhoto<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1PersonIdPhotoMutationResponse,
      ResponseErrorConfig<
        | PostApiV1PersonIdPhoto400
        | PostApiV1PersonIdPhoto401
        | PostApiV1PersonIdPhoto404
        | PostApiV1PersonIdPhoto500
      >,
      {
        id: PostApiV1PersonIdPhotoPathParams["id"];
        data?: PostApiV1PersonIdPhotoMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1PersonIdPhotoMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1PersonIdPhotoMutationKey();

  const baseOptions = postApiV1PersonIdPhotoMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1PersonIdPhotoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdPhoto400
      | PostApiV1PersonIdPhoto401
      | PostApiV1PersonIdPhoto404
      | PostApiV1PersonIdPhoto500
    >,
    {
      id: PostApiV1PersonIdPhotoPathParams["id"];
      data?: PostApiV1PersonIdPhotoMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1PersonIdPhotoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdPhoto400
      | PostApiV1PersonIdPhoto401
      | PostApiV1PersonIdPhoto404
      | PostApiV1PersonIdPhoto500
    >,
    {
      id: PostApiV1PersonIdPhotoPathParams["id"];
      data?: PostApiV1PersonIdPhotoMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1PersonIdPhotoMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdPhoto400
      | PostApiV1PersonIdPhoto401
      | PostApiV1PersonIdPhoto404
      | PostApiV1PersonIdPhoto500
    >,
    {
      id: PostApiV1PersonIdPhotoPathParams["id"];
      data?: PostApiV1PersonIdPhotoMutationRequest;
    },
    TContext
  >;
}
